import {useEffect, useState} from "react";
import {BreadCrumbs} from "../../../components/open/pages";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {ThinAddIcon, ThinEditIcon, ThinKeyIcon, ThinTrashIcon} from "../../../components/icons/material-icons";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {AdminsAddEditUserModal} from "./add-edit-user";
import {AdminsSetUserPermissionsModal} from "./permission";
import {RemoveModal} from "../../../components/template/remove-modal";

interface userInterface {
    id: number,
    name: string,
    role: string,
    tell: string,
}

export const AdminUsersScreen = () => {
    const [list, setList] = useState<userInterface[]>([]);
    const [loaded, setLoaded] = useState(false);
    const fetchList = () => {
        PostJSON(
            Apis.server + '/core/admins/users/list',
            {},
            true,
            (d: {
                result: string,
                reason: string,
                list: userInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    else if (d.reason === 'access')
                        ShowSnackbar(
                            'شما به این بخش دسترسی ندارید.',
                            'باشه',
                            5000,
                        );
                    return;
                }
                setList(d.list === null ? [] : d.list);
                setLoaded(true);
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "کاربران | نهال";
        fetchList();
    }, []);
    const [addEdit, setAddEdit] = useState({
        show: false,
        id: 0,
        edit: false,
    });
    const [perModal, setPerModal] = useState({
        show: false,
        id: 0,
    });
    const [removeModal,setRemoveModal] = useState({
        show:false,
        id:0,
        title:'',
    });
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'تنظیمات', url: '/admins/settings'},
                {title: 'کاربران', url: '/admins/settings/users'},
            ]}/>
            {
                loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>کاربران اتوماسیون</b>
                                <button onClick={() => setAddEdit({
                                    edit: false,
                                    id: 0,
                                    show: true,
                                })}>
                                    <ThinAddIcon/>
                                    <span>کاربر جدید</span>
                                </button>
                            </div>
                            <table className="table open-table table-striped table-hover table-bordered">
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>نام</th>
                                    <th>تلفن</th>
                                    <th>سمت</th>
                                    <th>امکانات</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    list.map((s, i) =>
                                        <tr key={"autoUsersAdmin2D83SSd_" + i}>
                                            <td>{CurrencyFormat(i + 1)}</td>
                                            <td>
                                                {s.name}
                                            </td>
                                            <td>
                                                {StringDigitsConvertToPersian(s.tell.replaceAll('+98', '0'))}
                                            </td>
                                            <td>{s.role}</td>
                                            <td>
                                                <div className="d-inline-flex align-items-center" style={{gap: 5}}>
                                                    <button className="open-tooltip" onClick={() => setPerModal({
                                                        show: true,
                                                        id: s.id,
                                                    })}>
                                                        <i>تنظیم دسترسی</i>
                                                        <ThinKeyIcon/>
                                                    </button>
                                                    <button className="open-tooltip" onClick={() => setAddEdit({
                                                        show: true,
                                                        id: s.id,
                                                        edit: true,
                                                    })}>
                                                        <i>ویرایش</i>
                                                        <ThinEditIcon/>
                                                    </button>
                                                    <button className="open-tooltip" onClick={()=>setRemoveModal({
                                                        title: s.name,
                                                        id: s.id,
                                                        show: true,
                                                    })}>
                                                        <i>حذف</i>
                                                        <ThinTrashIcon/>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                }
                                </tbody>
                            </table>
                        </div>
                    </div> : null
            }
            <AdminsAddEditUserModal
                active={addEdit.show}
                closeHandler={() => setAddEdit(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                isEdit={addEdit.edit}
                id={addEdit.id}
                onDone={() => {
                    ShowProgressLoading();
                    fetchList();
                }}
            />
            <AdminsSetUserPermissionsModal
                active={perModal.show}
                closeHandler={() => setPerModal(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                id={perModal.id}
            />
            <RemoveModal
                active={removeModal.show}
                closeHandler={() => setRemoveModal(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                title={"حذف کاربر"}
                desc={"آیا مطمئن هستید که می‌خواهید " + removeModal.title + " را حذف کنید؟"}
                onRemove={() => {
                    const x = {...removeModal};
                    ShowProgressLoading();
                    PostJSON(
                        Apis.server + '/core/admins/users/remove',
                        {
                            id: x.id,
                        },
                        true,
                        (d: {
                            result: string,
                            reason: string | undefined,
                        }) => {
                            HideProgressLoading();
                            if (d.result !== 'OK') {
                                if (d.reason === 'login')
                                    AuthRedirectAdmins();
                                return;
                            }
                            ShowSnackbar(
                                'کاربر حذف گردید.',
                                'باشه',
                                5000,
                            );
                            ShowProgressLoading();
                            fetchList();
                        },
                        () => {
                        },
                        AuthRedirectAdmins,
                    ).then(void 0);
                }}
            />
        </>
    );
};